module.exports = __webpack_public_path__ + "img/invio_presenze2.14bde707.png";